(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/modules/racing-game/components/play-context/assets/javascripts/reducer.js') >= 0) return;  svs.modules.push('/modules/racing-game/components/play-context/assets/javascripts/reducer.js');
"use strict";

const _excluded = ["participants", "participantsMeta"];
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], t.indexOf(o) >= 0 || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.indexOf(n) >= 0) continue; t[n] = r[n]; } return t; }

const actionTypes = svs.racing_game.components.playContext.actionTypes;
const {
  utils: {
    merge
  }
} = svs.racing.raceService;
const reducer = (state, action) => {
  switch (action.type) {
    case actionTypes.SET_RACE:
      {
        return action.race;
      }
    case actionTypes.UPDATE_CURRENT_RACE:
      {
        const _action$race = action.race,
          {
            participants,
            participantsMeta
          } = _action$race,
          restOfRaceData = _objectWithoutProperties(_action$race, _excluded);
        const participantNumberSortOrder = participants.map(participant => participant.participantNumber);
        const newRaceData = _objectSpread(_objectSpread(_objectSpread({}, state), restOfRaceData), {}, {
          participants: participants.map(merge.mergeRaceParticipant(state)),
          participantsMeta: participantsMeta.map(merge.mergeRaceParticipantMeta(state, participantNumberSortOrder))
        });
        return newRaceData;
      }
    case actionTypes.UPDATE_CURRENT_WINODDS:
      {
        if (!state) {
          return;
        }
        const {
          winodds
        } = action;
        const newRaceData = _objectSpread(_objectSpread({}, state), {}, {
          oddsTime: winodds.oddsTime,
          refOddsTime: winodds.refOddsTime,
          participants: state.participants.map(merge.mergeWinoddsParticipant(winodds)),
          participantsMeta: state.participantsMeta.map(merge.mergeWinoddsParticipantMeta(winodds))
        });
        return newRaceData;
      }
    case actionTypes.UPDATE_CURRENT_SHOWODDS:
      {
        if (!state) {
          return;
        }
        const {
          showodds
        } = action;
        const newRaceData = _objectSpread(_objectSpread({}, state), {}, {
          oddsTime: showodds.oddsTime,
          participantsMeta: state.participantsMeta.map(meta => meta.key === 'showOdds' ? merge.mergeShowodds(meta, action.showodds) : meta)
        });
        return newRaceData;
      }
    case actionTypes.UPDATE_CURRENT_DISTRIBUTION:
      {
        if (!state) {
          return;
        }
        const newRaceData = _objectSpread(_objectSpread({}, state), {}, {
          participantsMeta: state.participantsMeta.map(meta => meta.key === 'distribution' ? merge.mergeDistributionMeta(meta, action.distribution) : meta)
        });
        return newRaceData;
      }
    case actionTypes.UPDATE_CURRENT_IO_DISTRIBUTION:
      {
        if (!state) {
          return;
        }
        const newRaceData = _objectSpread(_objectSpread({}, state), {}, {
          participantsMeta: state.participantsMeta.map(meta => meta.key === 'ioDistribution' ? merge.mergeDistributionMeta(meta, action.ioDistribution) : meta)
        });
        return newRaceData;
      }
    default:
      return state;
  }
};
svs.racing_game.components.playContext.reducer = reducer;

 })(window);